// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"7c5cd5d6","498":"08e1e2c8","598":"d697872b","787":"c4e7f8f9"}[chunkId] + ".chunk.js";
};